/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_profile_tooltip_fantasy_h2h = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fantasy points delta per race - green means first driver scored more`)
};

const es_f1_profile_tooltip_fantasy_h2h = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diferencia de puntos fantasy por GP - verde significa que el primer piloto puntuó más`)
};

const de_f1_profile_tooltip_fantasy_h2h = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fantasy-Punkte-Delta pro Rennen — Grün bedeutet erster Fahrer hat mehr erzielt`)
};

const nl_f1_profile_tooltip_fantasy_h2h = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fantasy-puntenverschil per race — groen betekent dat de eerste coureur meer scoorde`)
};

const fr_f1_profile_tooltip_fantasy_h2h = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delta de points fantasy par course — vert signifie que le premier pilote a marqué plus`)
};

const it_f1_profile_tooltip_fantasy_h2h = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delta punti fantasy per gara — verde significa che il primo pilota ha segnato di più`)
};

const pt_br2_f1_profile_tooltip_fantasy_h2h = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delta de pontos fantasy por corrida — verde significa que o primeiro piloto pontuou mais`)
};

const pt_f1_profile_tooltip_fantasy_h2h = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delta de pontos fantasy por corrida — verde significa que o primeiro piloto marcou mais`)
};

const ja_f1_profile_tooltip_fantasy_h2h = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レースごとのファンタジーポイント差 — グリーンは先ドライバーがより多く獲得`)
};

const zh_f1_profile_tooltip_fantasy_h2h = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每场梦幻积分差 — 绿色表示第一位车手得分更高`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_profile_tooltip_fantasy_h2h = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_profile_tooltip_fantasy_h2h(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_profile_tooltip_fantasy_h2h", locale)
	if (locale === "en") return en_f1_profile_tooltip_fantasy_h2h(inputs)
	if (locale === "es") return es_f1_profile_tooltip_fantasy_h2h(inputs)
	if (locale === "de") return de_f1_profile_tooltip_fantasy_h2h(inputs)
	if (locale === "nl") return nl_f1_profile_tooltip_fantasy_h2h(inputs)
	if (locale === "fr") return fr_f1_profile_tooltip_fantasy_h2h(inputs)
	if (locale === "it") return it_f1_profile_tooltip_fantasy_h2h(inputs)
	if (locale === "pt-BR") return pt_br2_f1_profile_tooltip_fantasy_h2h(inputs)
	if (locale === "pt") return pt_f1_profile_tooltip_fantasy_h2h(inputs)
	if (locale === "ja") return ja_f1_profile_tooltip_fantasy_h2h(inputs)
	return zh_f1_profile_tooltip_fantasy_h2h(inputs)
};